import React, { useState } from "react";
import {
  IFeaturedPropertiesProps,
  IPropertyObject,
} from "./FeaturedPropertiesProps";
import {
  StyledContainer,
  StyledSubtitle,
  Title,
} from "./FeaturedPropertiesHelpers";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import Badge from "react-bootstrap/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ParagraphAnchorLink from "../ParagraphAnchorLink/ParagraphAnchorLink";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const FeaturedProperties: React.FC<IFeaturedPropertiesProps> = (props) => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex: any) => {
    setIndex(selectedIndex);
  };
  const handleNavigate = (action: any) => {
    let goTo = 0;
    const lastSlide = carouselItems.length - 1;
    if (action === "previous") {
      goTo = index === 0 ? lastSlide : index - 1;
    }
    if (action === "next") {
      goTo = index !== lastSlide ? index + 1 : 0;
    }
    setIndex(goTo);
  };
  const isAltBackground = props?.bgColor === "alt";
  const properties: any = props.node?.relationships?.properties || [];
  const carouselItems: any = [];
  properties.forEach((property: IPropertyObject) => {
    if (property?.relationships?.hotel) {
      const image = property.relationships?.media?.relationships.image
        ? getImage(
            property.relationships.media.relationships.image.gatsbyImage as any
          )
        : null;
      carouselItems.push({ ...property, image: image });
    }
  });
  if (carouselItems.length) {
    return (
      <StyledContainer
        fluid
        className={`pt-5 pb-5 position-relative`}
        color={props.color}
      >
        <ParagraphAnchorLink id={props.node.id} />
        <Container fluid="sm" className="px-0 custom-padding">
          <Row className="mb-4">
            <Col className="text-center">
              <StyledSubtitle color={props.color}>
                {props.node.field_subtitle}
              </StyledSubtitle>
              <Title {...props} />
              {props.node.description && (
                <p
                  dangerouslySetInnerHTML={{ __html: props.node.description }}
                />
              )}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Carousel
                interval={null}
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                controls={false}
                fade
              >
                {carouselItems.map((item: any) => {
                  const hotel = item.relationships.hotel;
                  const image = item.image;
                  const tag = hotel.relationships.field_tags || null;
                  return (
                    <Carousel.Item key={item.id}>
                      <Row className="g-0">
                        <Col
                          className="carousel-image h-100"
                          lg={{ span: 6, order: 2 }}
                        >
                          {!!image && typeof image != "string" && (
                            <GatsbyImage
                              image={image}
                              alt={`${hotel.name} Image`}
                            />
                          )}
                        </Col>
                        <Col
                          className={`text-center carousel-text border h-100 ${
                            isAltBackground ? "white-background" : ""
                          }`}
                          lg={{ span: 6 }}
                        >
                          <div className="p-3 h-100 d-flex flex-column">
                            <div className="pt-lg-4 mt-lg-4">
                              <div className="title-styles-h4">
                                <h4>{hotel.name}</h4>
                              </div>
                            </div>
                            {tag && (
                              <Badge
                                variant="primary"
                                className="rounded-0 mb-3 align-self-center"
                              >
                                {tag.name}
                              </Badge>
                            )}
                            {item.field_description && (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: item.field_description,
                                }}
                                className="text-center set-max-height"
                              />
                            )}
                            <Link
                              to={hotel.path.alias}
                              state={{ defaultSearch: true }}
                              className="teaser-link align-self-center"
                            >
                              View Property
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <ul className="carousel-controls list-unstyled d-none d-sm-inline-flex m-0 align-items-center me-4">
                <li
                  className="me-2"
                  title="Previous"
                  onClick={() => handleNavigate("previous")}
                >
                  <FontAwesomeIcon icon="chevron-left" aria-hidden={true} />
                  <span className="sr-only">Previous</span>
                </li>
                <li title="Next" onClick={() => handleNavigate("next")}>
                  <FontAwesomeIcon icon="chevron-right" aria-hidden={true} />
                  <span className="sr-only">Next</span>
                </li>
              </ul>
              <ol className="carousel-indicators position-relative m-0 d-inline-flex">
                {carouselItems.map((item: any, itemIndex: any) => {
                  return (
                    <li
                      key={item.id}
                      className={index === itemIndex ? "active" : ""}
                      onClick={() => handleSelect(itemIndex)}
                    />
                  );
                })}
              </ol>
            </Col>
          </Row>
        </Container>
      </StyledContainer>
    );
  }
  return <></>;
};

export default FeaturedProperties;
